import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "label" }
const _hoisted_2 = { class: "label__split label__split__left" }
const _hoisted_3 = { class: "label__split label__split__right" }

import { computed } from 'vue'
import { useStore } from 'vuex'
import { INDOORVIEWER_PREFIX } from '@/store/module-prefixes'


export default /*@__PURE__*/_defineComponent({
  __name: 'IndoorviewerLabel',
  setup(__props) {

const store = useStore()

const instanceLinks = computed(() => store.state[INDOORVIEWER_PREFIX].instanceLinks)
const primaryInstance = computed(() => store.state[INDOORVIEWER_PREFIX].primaryInstance)
const secondaryInstance = computed(() => store.state[INDOORVIEWER_PREFIX].secondaryInstance)

const titleLeft = computed(() => {
  return instanceLinks.value[primaryInstance.value].title ?? `Site ${primaryInstance.value + 1}`
})
const titleRight = computed(() => {
  return instanceLinks.value[secondaryInstance.value].title ?? `Site ${secondaryInstance.value + 1}`
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, _toDisplayString(titleLeft.value), 1),
    _createElementVNode("p", _hoisted_3, _toDisplayString(titleRight.value), 1)
  ]))
}
}

})